import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Col, Row } from 'reactstrap';
import { connect, useSelector } from 'react-redux';
import { ADDRESS_TYPE_HUB_CUSTOMER, ADDRESS_TYPE_ANOTHER_HUB, ADDRESS_TYPE_MERCHANT, MERCHANT_ROLE_ID, ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import renderSelectField from 'src/shared/components/form/Select';
import HubCustomerInformation from './HubCustomerInformation';

const required = value => value ? undefined : 'Required'

const DropOffOrder = ({ assignedHubForCustomer, isInfo }) => {
    
  const orderPreferences = useSelector(state => state.orderPreferences);
    const [addressTypeId, setAddressTypeId] = useState(null);
    const [isCustomersId, setCustomersId] = useState([]);
    const [isMerchant, setMerchant] = useState([]);

    useEffect(() => {
        if (localStorage.getItem("uri") === MERCHANT_ROLE_ID) {
            if(orderPreferences?.data?.merchantEnabled){
            getAllMerchantDetails();
            }
        } else {
            getAllCustomerDetails();
        }
        if (isInfo?.orderToAddressTypeInfo?.orderAddressTypeId) {
            setAddressTypeId(isInfo.orderToAddressTypeInfo.orderAddressTypeId);
            if (isInfo.orderToAddressTypeInfo.orderAddressTypeId === ADDRESS_TYPE_MERCHANT) {
                getAllMerchantDetails();
            } else if (isInfo.orderToAddressTypeInfo.orderAddressTypeId === ADDRESS_TYPE_HUB_CUSTOMER) {
                getAllCustomerDetails();
            }
        }
    }, [isInfo]);

    const getAllMerchantDetails = async () => {
        try {
            let merchantIds = [];
            const response = await PndRestApi.GetAllMerchantDetails();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    merchantIds.push({ "label": item.merchantName, "value": item.merchantId });
                });
                setMerchant(merchantIds);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const getAllCustomerDetails = async () => {
        try {
            let customersId = [];
            const response = await PndRestApi.GetAllHubCustomers();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.forEach(item => {
                    customersId.push({ "label": item.customerName, "value": item.hubCustomerId });
                });
                setCustomersId(customersId);
            } 
            // else {
            //     showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data?.message || "Error"}`);
            // }
        } catch (error) {
            showNotification("theme-light", "ltr", "SuccessCode: 500", ERROR_MESSAGES.tryCatchError);
        }
    };

    const findAddressType = (val) => {
        setAddressTypeId(val);
        // if (val === ADDRESS_TYPE_MERCHANT) getAllMerchantDetails();
        // if (val === ADDRESS_TYPE_HUB_CUSTOMER) getAllCustomerDetails();
    }

    return (
        <div className="mt-2">
            <Row className="g-2 mb-3">
                <Col lg={3} md={6}>
                    <div className="mb-1">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off To <span className='text-danger'>*</span></label>
                        <Field validate={[required]} name="orderToAddressTypeInfo" component={renderSelectField} options={[
                            { value: 2, label: "Hub Customer" },
                            { value: 3, label: "Merchant" },
                            { value: 4, label: "Another Hub" },
                        ]} isDisabled={!!isInfo?.orderNo} placeholder="Select Delivery Destination" onChange={e => findAddressType(e?.value)} />
                    </div>
                </Col>

                {addressTypeId === ADDRESS_TYPE_ANOTHER_HUB && (
                    <Col lg={3} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Target Hub <span className='text-danger'>*</span></label>
                            <Field validate={[required]} name="hubInfo" component={renderSelectField} options={assignedHubForCustomer} placeholder="Select Hub" />
                        </div>
                    </Col>
                )}

                {addressTypeId === ADDRESS_TYPE_MERCHANT && (
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Merchant <span className='text-danger'>*</span></label>
                            <Field validate={[required]} name="merchantInfo" component={renderSelectField} options={isMerchant} placeholder="Select Merchant" />
                        </div>
                    </Col>
                )}
            </Row>

            {addressTypeId === ADDRESS_TYPE_HUB_CUSTOMER && (
                <HubCustomerInformation isCustomersId={isCustomersId} />
            )}
        </div>
    );
};

DropOffOrder.propTypes = {
    isInfo: PropTypes.object,
    assignedHubForCustomer: PropTypes.array,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(DropOffOrder));
